import { Fields, Validators } from "./TinySuppressionImporter.types";

const getValidatorsForType = (suppressionType: string): Validators => {
  switch (suppressionType) {
    case "EMAIL":
      return [
        { validate: "required" },
        { validate: "unique" },
        {
          validate: "regex_matches",
          regex:
            '^(([^<>()[\\]\\.,;:\\s@"]+(\\.[^<>()[\\]\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
          error: "Invalid email.",
        },
      ];
    case "MD5":
    case "SHA256":
      return [
        {
          validate: "regex_matches",
          regex:
            suppressionType === "MD5"
              ? "^[a-fA-F0-9]{32}$"
              : "^[a-fA-F0-9]{64}$",
          error: `Invalid ${suppressionType.toUpperCase()} hash.`,
        },
      ];
    default:
      return [];
  }
};

const getLabel = (suppressionType: string) => {
  switch (suppressionType) {
    case "EMAIL":
      return "Email Address";
    case "MD5":
      return "MD5 hash";
    case "SHA256":
      return "SHA256 hash";
    default:
      return "";
  }
};

export default function useTinyImporter(suppressionType: string) {
  const fields: Fields = [
    {
      label: getLabel(suppressionType),
      key: "value",
      validators: getValidatorsForType(suppressionType),
    },
  ];

  return {
    fields,
  };
}
